import React, { Component, Fragment } from "react";
import "./dealSumCalc.css";
import { withRouter } from "react-router-dom";
import {
  TextField,
  Typography,
  Button,
  Tooltip,
  Box,
  Menu,
  MenuItem,
  CircularProgress,
  Collapse,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from "@material-ui/core";
import {
  FilterFrames,
  GetApp
} from "@material-ui/icons";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import DescriptionOutlinedIcon from "@material-ui/icons/DescriptionOutlined";
import GetAppOutlinedIcon from "@material-ui/icons/GetAppOutlined";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import PersonIcon from "@material-ui/icons/Person";
import PieChartIcon from "@material-ui/icons/PieChart";
import LabeledTextField from "./output/ClassicLabeledTextField";
import ClassicAddressAutocomplete from "./output/ClassicAddressAutocomplete";
import CustomAcordion from "../../layout/CustomAcordion";
import HelpDialog from "../../layout/HelpDialog";
import filesService from "../../../services/docsService/filesService";
import adminService from "../../../services/adminService";
import fieldsData from "../../../services/docsService/fieldsData";
import { searchLotParcelFromAddress } from "../../../services/govMapApi";
import config from "../../../config";
import Swal from "sweetalert2";
import { connect } from "react-redux";
import { confirmTaxAuthorityDocumentGenerationOncePerDeal } from "../../shared/dialogs/taxAuthorityDocumentConfirm";
import {
  DOC_2990_AUTOFILL_TARGET_FIELDS,
  buildPropertyAutofillPatch,
  parseSmartLookupAddress,
  resolveClassicCatalogAddress,
  validate2990JsonFieldsDetailed
} from "./output/classic2990Helpers";
import {
  CLASSIC_2990_ACTIONS,
  CLASSIC_2990_FIELD_LABELS,
  CLASSIC_2990_FIELD_TOOLTIPS,
  CLASSIC_2990_LABELS,
  CLASSIC_2990_MESSAGES,
  CLASSIC_2990_SMART_ADDRESS_HELP,
  getClassic2990ParcelChoiceLabel
} from "./output/classic2990Texts";
import ClassicNoTaxOutcome from "./output/ClassicNoTaxOutcome";
import { CLASSIC_ANALYSIS_RESULTS_LABELS } from "./output/classicOutputTexts";
import { COMPACT_CURRENCY_LABELS } from "./output/classicCurrencyLabels";
import { formatClassicWholeMoney } from "./output/classicMoneyHelpers";
import {
  formatClassicAdjustmentLabel,
  getClassic2990RequestFields,
  getClassicLoadedSellerId,
  getClassicOutputExemptionLabels,
  getClassicOutputRow,
  getClassicOutputTaxBeforeAdjustments,
  getClassicOutputVariantRows,
  getClassicPrisaYearUnit,
  isClassicOutputFullyExempt
} from "./classicOutputHelpers";

const SHEKEL_LABEL = COMPACT_CURRENCY_LABELS.newShekel;
const SELLER_INPUT_WIDTH = 124;
const OFFICE_INPUT_WIDTH = 128;
const PROPERTY_INPUT_WIDTH = 124;
const FRACTION_INPUT_WIDTH = 124;
const PARCEL_SEARCH_INPUT_ID = "classic-2990-parcelAddressSearch";
const getClassic2990FieldId = (fieldName) => `classic-2990-${fieldName}`;

const CLASSIC_PROPERTY_TYPE_LABELS = {
  dmm: "דירת מגורים מזכה",
  otherProperty: "זכות אחרת",
  sharesInUnion: "מניות באיגוד מקרקעין",
  apartment: "דירה"
};

const RESULTS_COLUMNS = [
  { key: "propertyType", label: CLASSIC_ANALYSIS_RESULTS_LABELS.propertyType, align: "right", frame: true },
  { key: "saleValue", label: CLASSIC_ANALYSIS_RESULTS_LABELS.saleValue, frame: true },
  { key: "nominalAcquisitionPrice", label: CLASSIC_ANALYSIS_RESULTS_LABELS.nominalAcquisitionPrice, pair: "start" },
  { key: "indexedAcquisitionPrice", label: CLASSIC_ANALYSIS_RESULTS_LABELS.indexedAcquisitionPrice, pair: "end" },
  { key: "nominalExpenses", label: CLASSIC_ANALYSIS_RESULTS_LABELS.nominalExpenses, pair: "start" },
  { key: "indexedExpenses", label: CLASSIC_ANALYSIS_RESULTS_LABELS.indexedExpenses, pair: "end" },
  { key: "depreciation", label: CLASSIC_ANALYSIS_RESULTS_LABELS.depreciation, frame: true },
  { key: "totalShevach", label: CLASSIC_ANALYSIS_RESULTS_LABELS.propertyShevach, isTotal: true, frame: true },
  { key: "capitalGainsTax", label: CLASSIC_ANALYSIS_RESULTS_LABELS.partTax, isTotal: true, frame: true }
];

const SELLER_FIELDS = [
  { type: "text", label: CLASSIC_2990_FIELD_LABELS.sellerFirstName, name: "sellerFirstName", maxLength: "17", textFieldWidth: SELLER_INPUT_WIDTH },
  { type: "text", label: CLASSIC_2990_FIELD_LABELS.sellerLastName, name: "sellerLastName", maxLength: "17", textFieldWidth: SELLER_INPUT_WIDTH },
  {
    type: "number",
    label: CLASSIC_2990_FIELD_LABELS.sellerId,
    name: "sellerId",
    noComma: true,
    sequencesOfZerosAllowed: true,
    maxLength: "9",
    tooltip: CLASSIC_2990_FIELD_TOOLTIPS.sellerId,
    textFieldWidth: SELLER_INPUT_WIDTH
  },
  {
    type: "select",
    label: CLASSIC_2990_FIELD_LABELS.lishcatRishumLocation,
    name: "lishcatRishumLocation",
    useOfficeOptions: true,
    textFieldWidth: OFFICE_INPUT_WIDTH
  }
];

const PROPERTY_FIELDS = [
  { type: "text", label: CLASSIC_2990_FIELD_LABELS.assetCity, name: "assetCity", addressAutocomplete: true, textFieldWidth: PROPERTY_INPUT_WIDTH },
  { type: "text", label: CLASSIC_2990_FIELD_LABELS.assetStreet, name: "assetStreet", addressAutocomplete: true, textFieldWidth: PROPERTY_INPUT_WIDTH },
  { type: "number", label: CLASSIC_2990_FIELD_LABELS.assetStreetNumber, name: "assetStreetNumber", noComma: true, maxLength: "5", textFieldWidth: PROPERTY_INPUT_WIDTH },
  { type: "number", label: CLASSIC_2990_FIELD_LABELS.assetHouseNum, name: "assetHouseNum", noComma: true, maxLength: "4", textFieldWidth: PROPERTY_INPUT_WIDTH },
  { type: "number", label: CLASSIC_2990_FIELD_LABELS.assetZipcode, name: "assetZipcode", noComma: true, maxLength: "7", textFieldWidth: PROPERTY_INPUT_WIDTH },
  { type: "number", label: CLASSIC_2990_FIELD_LABELS.blockNum, name: "blockNum", noComma: true, maxLength: "6", textFieldWidth: PROPERTY_INPUT_WIDTH },
  { type: "number", label: CLASSIC_2990_FIELD_LABELS.subBlock, name: "subBlock", noComma: true, maxLength: "4", textFieldWidth: PROPERTY_INPUT_WIDTH },
  { type: "number", label: CLASSIC_2990_FIELD_LABELS.subSubBlock, name: "subSubBlock", noComma: true, maxLength: "3", textFieldWidth: PROPERTY_INPUT_WIDTH }
];

const FRACTION_DENOMINATOR_FIELD = {
  type: "number",
  label: CLASSIC_2990_LABELS.denominator,
  name: "passPartMekarkeinMechane",
  noComma: true,
  maxLength: "12",
  textFieldWidth: FRACTION_INPUT_WIDTH
};

const FRACTION_NUMERATOR_FIELD = {
  type: "number",
  label: CLASSIC_2990_LABELS.numerator,
  name: "passPartMekarkeinMone",
  noComma: true,
  maxLength: "12",
  textFieldWidth: FRACTION_INPUT_WIDTH
};

function getResultsColumnClassName(column, { includeWidth = false } = {}) {
  return [
    includeWidth
      ? (column.key === "propertyType"
        ? "classic-output-property-col"
        : `classic-output-amount-col${column.key === "nominalExpenses" ? " classic-output-expense-col" : ""}`)
      : "",
    column.pair ? "classic-output-pair" : "",
    column.pair === "start" ? "classic-output-pair-start" : "",
    column.pair === "end" ? "classic-output-pair-end" : "",
    column.frame ? "classic-output-frame" : ""
  ].filter(Boolean).join(" ");
}

function getCompactCurrencyLabel(currency) {
  return COMPACT_CURRENCY_LABELS[currency] || SHEKEL_LABEL;
}

function formatClassicOutputCurrency(value, currencyLabel = SHEKEL_LABEL) {
  const formatted = formatClassicWholeMoney(value, { empty: "-" });
  if (!formatted || formatted === "-") return formatted;
  return (
    <>
      <span className="classic-output-currency">{currencyLabel}</span>
      <span className="classic-output-currency-value">{formatted}</span>
    </>
  );
}

const SMART_ADDRESS_HELP_DIALOG = (
  <Box textAlign="right">
    <Typography variant="body2" component="div" gutterBottom>
      {CLASSIC_2990_SMART_ADDRESS_HELP.formatsTitle}
    </Typography>
    <ul style={{ margin: "8px 0 0", paddingRight: "18px" }}>
      {CLASSIC_2990_SMART_ADDRESS_HELP.formats.map((format) => (
        <li key={format}>{format}</li>
      ))}
    </ul>
    <Typography variant="body2" component="div" style={{ marginTop: 12 }}>
      {CLASSIC_2990_SMART_ADDRESS_HELP.examplesTitle}
      {CLASSIC_2990_SMART_ADDRESS_HELP.examples.map((example) => (
        <React.Fragment key={example}>
          <br />
          {example}
        </React.Fragment>
      ))}
    </Typography>
  </Box>
);

class ClassicDealSumCalc extends Component {
  parcelMenuAnchorRef = React.createRef();
  propertyBlockRef = React.createRef();
  parcelLookupReq = 0;
  fieldRefs = {};
  fieldRefCallbacks = {};

  registerFieldRef = (fieldName) => {
    if (!this.fieldRefCallbacks[fieldName]) {
      this.fieldRefCallbacks[fieldName] = (node) => {
        if (node) this.fieldRefs[fieldName] = node;
        else delete this.fieldRefs[fieldName];
      };
    }
    return this.fieldRefCallbacks[fieldName];
  };

  state = {
    doc2990Fields: {},
    cities: null,
    streets: [],
    showDoc2990Fields: false,
    parcelAddressSearch: "",
    isAddressSearchLoading: false,
    parcelAddressError: "",
    isGovMapAutofill: false,
    addressChoices: [],
    addressMenuAnchor: null,
    adjustmentsOpen: false,
    jsonFieldErrors: {}
  };

  componentDidMount() {
    filesService.getDocsFields(this.props.match.params.dealId, true).then((res) => {
      if (res.success) {
        const doc2990Fields = {
          ...res.data,
          sellerId: getClassicLoadedSellerId(res.data.sellerId),
          blockNum: res.data.blockNum ? parseInt(res.data.blockNum) : null,
          subBlock: res.data.subBlock ? parseInt(res.data.subBlock) : null,
          subSubBlock: res.data.subSubBlock ? parseInt(res.data.subSubBlock) : null,
          assetStreetNumber: res.data.assetStreetNumber ? parseInt(res.data.assetStreetNumber) : null,
          assetZipcode: res.data.assetZipcode ? parseInt(res.data.assetZipcode) : null,
          assetHouseNum: res.data.assetHouseNum ? parseInt(res.data.assetHouseNum) : null,
          passPartMekarkeinMechane: res.data.passPartMekarkeinMechane ? parseInt(res.data.passPartMekarkeinMechane) : null,
          passPartMekarkeinMone: res.data.passPartMekarkeinMone ? parseInt(res.data.passPartMekarkeinMone) : null
        };
        this.setState({ doc2990Fields, showDoc2990Fields: true });
      }
    });
    this.placeClassicOutputExtension();
    this.observeClassicOutputTable();
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.state.cities) {
      if (this.props.addresses) {
        let cities = [];
        for (const curAddress of this.props.addresses) {
          if (!cities.includes(curAddress.cityName)) cities.push(curAddress.cityName);
        }
        this.setState({ cities });
      }
    }
    if (prevState.adjustmentsOpen === this.state.adjustmentsOpen) {
      this.placeClassicOutputExtension();
    }
  }

  componentWillUnmount() {
    if (this.classicOutputTableObserver) {
      this.classicOutputTableObserver.disconnect();
      this.classicOutputTableObserver = null;
    }
  }

  placeClassicOutputExtension = (block = this.propertyBlockRef.current) => {
    if (!block) return;
    const table = block.querySelector("table");
    const extension = block.querySelector(".classic-output-extension");
    if (!table || !extension) return;
    const heads = [...table.querySelectorAll("thead th")].slice(-3);
    if (heads.length < 3) return;
    const container = block.querySelector(".classic-output-property-table");
    const blockBox = block.getBoundingClientRect();
    const boxes = heads.map((head) => head.getBoundingClientRect());
    const left = boxes[2].left - blockBox.left - 1;
    const right = boxes[0].right - blockBox.left;
    const containerBottom = container
      ? container.getBoundingClientRect().bottom
      : boxes[0].bottom;
    const top = containerBottom - blockBox.top - 1;
    extension.style.top = `${top}px`;
    extension.style.left = `${left}px`;
    extension.style.width = `${Math.max(right - left, 0)}px`;
    extension.style.setProperty(
      "--classic-output-tail-columns",
      `${boxes[0].width}px ${boxes[1].width}px ${boxes[2].width + 1}px`
    );
    const collapseNode = extension.querySelector(".classic-output-adjustments-collapse");
    const hiddenRowsHeight = !this.state.adjustmentsOpen && collapseNode ? collapseNode.offsetHeight : 0;
    block.style.paddingBottom = `${extension.offsetHeight - hiddenRowsHeight}px`;
  };

  reserveClassicOutputAdjustmentsSpace = (collapseNode, expanded) => {
    const block = this.propertyBlockRef.current;
    const extension = block?.querySelector(".classic-output-extension");
    if (!block || !extension || !collapseNode) return;
    const fixedRowsHeight = extension.offsetHeight - collapseNode.offsetHeight;
    block.style.paddingBottom = `${fixedRowsHeight + (expanded ? collapseNode.scrollHeight : 0)}px`;
  };

  observeClassicOutputTable() {
    const block = this.propertyBlockRef.current;
    if (!block || typeof ResizeObserver === "undefined") return;
    const table = block.querySelector("table");
    if (!table) return;
    if (this.classicOutputTableObserver) this.classicOutputTableObserver.disconnect();
    this.classicOutputTableObserver = new ResizeObserver(() => this.placeClassicOutputExtension(block));
    this.classicOutputTableObserver.observe(table);
  }

  focusClassic2990Field(fieldName) {
    const fieldElement = this.fieldRefs[fieldName];
    if (!fieldElement) return;

    if (typeof fieldElement.scrollIntoView === "function") {
      fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
    }
    const focusTarget = fieldElement.querySelector("input, textarea, button, [tabindex]");
    if (focusTarget && typeof focusTarget.focus === "function") {
      try {
        focusTarget.focus({ preventScroll: true });
      } catch {
        focusTarget.focus();
      }
    }
  }

  render2990FieldControl(field, fieldId, { className = "", hideHelper = false } = {}) {
    const value = this.state.doc2990Fields[field.name];
    const fieldError = this.state.jsonFieldErrors[field.name];
    const inputNode = field.addressAutocomplete ? (
      <ClassicAddressAutocomplete
        addresses={this.props.addresses || []}
        city={this.state.doc2990Fields.assetCity}
        error={Boolean(fieldError)}
        helperText={hideHelper ? undefined : fieldError}
        id={fieldId}
        label={field.label}
        name={field.name}
        onChange={field.name === "assetCity"
          ? (event) => this.onCityChange(event.target.value)
          : this.handleOnChange}
        textFieldWidth={field.textFieldWidth}
        value={value}
      />
    ) : (
      <LabeledTextField
        type={field.type}
        id={fieldId}
        selectLabelId={field.type === "select" ? `${fieldId}-label` : undefined}
        name={field.name}
        value={value}
        maxLength={field.maxLength}
        noComma={field.noComma}
        sequencesOfZerosAllowed={field.sequencesOfZerosAllowed}
        textFieldWidth={field.textFieldWidth}
        options={field.useOfficeOptions ? fieldsData.lishcatRishumLocation.options : undefined}
        labelSpacing={0}
        inputSpacing={0}
        error={Boolean(fieldError)}
        helperText={hideHelper ? undefined : fieldError}
        onChange={this.handleOnChange}
      />
    );

    return (
      <div
        className={["classic-2990-pair-control", className, fieldError ? "is-error" : ""].filter(Boolean).join(" ")}
        ref={this.registerFieldRef(field.name)}
      >
        {field.tooltip ? (
          <Tooltip title={field.tooltip} placement="bottom-start">
            <div>{inputNode}</div>
          </Tooltip>
        ) : inputNode}
      </div>
    );
  }

  renderAdminDocActions() {
    return (
      <Fragment>
        <Button
          className="deal-sum-admin-btn"
          variant="outlined"
          endIcon={<FilterFrames style={{ marginRight: "8px" }} />}
          onClick={this.addDealTest}
        >
          שמירה כטסט
        </Button>
        <Button
          className="deal-sum-admin-btn"
          variant="outlined"
          endIcon={<GetApp style={{ marginRight: "8px" }} />}
          onClick={() => this.props.exportDealData()}
        >
          ייצא
        </Button>
      </Fragment>
    );
  }

  render2990FieldPair(field) {
    const fieldId = getClassic2990FieldId(field.name);
    return (
      <div className="classic-2990-pair" key={field.name}>
        <label className="classic-2990-pair-label" htmlFor={fieldId} id={`${fieldId}-label`}>
          {field.label}
        </label>
        {this.render2990FieldControl(field, fieldId)}
      </div>
    );
  }

  render() {
    const preCalc = this.props.preCalc;
    const mainCalc = this.props.mainCalc;
    const outputRow = getClassicOutputRow(preCalc, mainCalc);
    const variantRows = getClassicOutputVariantRows(mainCalc);
    const taxBeforeAdjustments = getClassicOutputTaxBeforeAdjustments(outputRow.payableTax, variantRows);
    const preCalcPartsData = preCalc && preCalc.preCalcPartsData ? preCalc.preCalcPartsData : [];
    const propertyTypeLabel = CLASSIC_PROPERTY_TYPE_LABELS[preCalc.propertyType] || CLASSIC_ANALYSIS_RESULTS_LABELS.genericAsset;
    const labels = getClassicOutputExemptionLabels(preCalc);
    const isFullyExempt = isClassicOutputFullyExempt(preCalc);
    const {
      parcelAddressSearch,
      isAddressSearchLoading,
      parcelAddressError,
      isGovMapAutofill,
      addressChoices,
      addressMenuAnchor,
      jsonFieldErrors
    } = this.state;
    const fractionErrors = [
      jsonFieldErrors[FRACTION_NUMERATOR_FIELD.name],
      jsonFieldErrors[FRACTION_DENOMINATOR_FIELD.name]
    ].filter(Boolean);

    return (
      <Box className="classic-output deal-sum-calc">
        <div className="pre-calc-sections classic-output-sections">
          <CustomAcordion summaryText={CLASSIC_ANALYSIS_RESULTS_LABELS.resultsTitle} defaultExpanded={true}>
            <div className="classic-output-property-block" ref={this.propertyBlockRef}>
              <TableContainer className="classic-output-table classic-output-data-table classic-output-property-table">
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      {RESULTS_COLUMNS.map((column) => (
                        <TableCell
                          key={column.key}
                          align={column.key === "propertyType" ? "right" : "center"}
                          className={getResultsColumnClassName(column, { includeWidth: true })}
                        >
                          {column.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell align="right" className="classic-output-property-col classic-output-frame">
                        <div className="classic-output-property">
                          <Typography variant="body2" className="classic-output-property-name">
                            {propertyTypeLabel}
                          </Typography>
                          {labels.length ? (
                            <Typography variant="caption" className="classic-output-property-meta">
                              {labels.join(" · ")}
                            </Typography>
                          ) : null}
                        </div>
                      </TableCell>
                      {RESULTS_COLUMNS.slice(1).map((column) => {
                        const currencyLabel = column.key === "nominalAcquisitionPrice"
                          ? getCompactCurrencyLabel(outputRow.nominalAcquisitionCurrency)
                          : SHEKEL_LABEL;
                        return (
                          <TableCell
                            key={column.key}
                            align="center"
                            className={getResultsColumnClassName(column) || undefined}
                          >
                            <Typography
                              variant="body2"
                              className={`classic-output-amount${column.isTotal ? " is-total" : ""}`}
                            >
                              {formatClassicOutputCurrency(outputRow[column.key], currencyLabel)}
                              {column.key === "saleValue" && outputRow.isGilum ? (
                                <span className="classic-output-gilum-tag">
                                  {CLASSIC_ANALYSIS_RESULTS_LABELS.gilumTag}
                                </span>
                              ) : null}
                            </Typography>
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
              <div className="classic-output-extension">
                <div className="classic-output-extension-row is-summary" role="row">
                  <div className="classic-output-extension-label" role="cell">
                    {CLASSIC_ANALYSIS_RESULTS_LABELS.tableTotal}
                  </div>
                  <div className="classic-output-amount is-total" role="cell">
                    {formatClassicOutputCurrency(outputRow.totalShevach)}
                  </div>
                  <div className="classic-output-amount is-total" role="cell">
                    {formatClassicOutputCurrency(taxBeforeAdjustments)}
                  </div>
                </div>
                <Collapse
                  className="classic-output-adjustments-collapse"
                  in={this.state.adjustmentsOpen}
                  onEnter={(node) => this.reserveClassicOutputAdjustmentsSpace(node, true)}
                  onEntered={() => this.placeClassicOutputExtension(this.propertyBlockRef.current)}
                  onExit={(node) => this.reserveClassicOutputAdjustmentsSpace(node, false)}
                  onExited={() => this.placeClassicOutputExtension(this.propertyBlockRef.current)}
                  timeout={260}
                  unmountOnExit
                >
                  <div role="rowgroup">
                    {variantRows.map((variantRow) => (
                      <div className="classic-output-extension-row" key={variantRow.key} role="row">
                        <div className="classic-output-extension-label is-wide" role="cell">
                          {formatClassicAdjustmentLabel(variantRow.label)}
                          {variantRow.yearCount > 0 ? (
                            <span className="classic-output-prisa-period">
                              {`ל-${variantRow.yearCount}\u00A0${getClassicPrisaYearUnit(variantRow.yearCount)}`}
                            </span>
                          ) : null}
                        </div>
                        <div className="classic-output-amount" role="cell">
                          {formatClassicOutputCurrency(variantRow.amount)}
                        </div>
                      </div>
                    ))}
                  </div>
                </Collapse>
                <div className="classic-output-extension-row is-payable" role="row">
                  <div className="classic-output-extension-label" role="cell">
                    <span>{CLASSIC_ANALYSIS_RESULTS_LABELS.totalTaxToPay}</span>
                  </div>
                  <div className="classic-output-adjustments-cell" role="cell">
                    <Button
                      className="classic-output-adjustments-toggle"
                      aria-expanded={this.state.adjustmentsOpen}
                      onClick={() => this.setState((prev) => ({ adjustmentsOpen: !prev.adjustmentsOpen }))}
                    >
                      <span>{CLASSIC_ANALYSIS_RESULTS_LABELS.showAdjustments}</span>
                      {this.state.adjustmentsOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </Button>
                  </div>
                  <div className="classic-output-amount is-total" role="cell">
                    {formatClassicOutputCurrency(outputRow.payableTax)}
                  </div>
                </div>
              </div>
            </div>
          </CustomAcordion>

          {isFullyExempt ? <ClassicNoTaxOutcome /> : null}

          {isFullyExempt && this.props.role === "admin" ? (
            <CustomAcordion summaryText={CLASSIC_2990_LABELS.documentsTitle} defaultExpanded={true}>
              <div className="deal-sum-docs">
                <div className="deal-sum-docs-block">
                  <div className="deal-sum-action-buttons">
                    {this.renderAdminDocActions()}
                  </div>
                </div>
              </div>
            </CustomAcordion>
          ) : null}

          {!isFullyExempt && this.state.showDoc2990Fields ? (
            <CustomAcordion summaryText={CLASSIC_2990_LABELS.panelTitle} defaultExpanded={true}>
              <div className="classic-2990-form">
                <div className="classic-2990-details">
                  <section className="classic-2990-seller">
                    <h3 className="classic-2990-section-title">
                      <PersonIcon className="classic-2990-section-icon" />
                      {CLASSIC_2990_LABELS.sellerDetails}
                    </h3>
                    <div className="classic-2990-seller-fields">
                      {SELLER_FIELDS.map((field) => this.render2990FieldPair(field))}
                    </div>
                  </section>

                  <section className="classic-2990-identity">
                    <h3 className="classic-2990-section-title">
                      <LocationOnIcon className="classic-2990-section-icon" />
                      {CLASSIC_2990_LABELS.propertyIdentification}
                    </h3>
                    <div className="classic-2990-lookup" ref={this.parcelMenuAnchorRef}>
                      <div className="classic-2990-lookup-label">
                        <label htmlFor={PARCEL_SEARCH_INPUT_ID}>{CLASSIC_2990_LABELS.propertyLookup}</label>
                        <HelpDialog
                          label={CLASSIC_2990_LABELS.propertyLookup}
                          helpDialog={SMART_ADDRESS_HELP_DIALOG}
                        />
                      </div>
                      <div className="classic-2990-lookup-field">
                        <TextField
                          id={PARCEL_SEARCH_INPUT_ID}
                          className="classic-2990-lookup-input"
                          name="parcelAddressSearch"
                          onChange={this.handleParcelSearchChange}
                          onKeyPress={this.handleAddressKeyPress}
                          placeholder={CLASSIC_2990_SMART_ADDRESS_HELP.placeholder}
                          size="small"
                          value={parcelAddressSearch}
                          variant="outlined"
                        />
                        <div className="classic-2990-lookup-status" aria-live="polite">
                          {parcelAddressError ? (
                            <span style={{ color: "#f44336", fontWeight: 600 }}>{parcelAddressError}</span>
                          ) : isGovMapAutofill ? (
                            <span style={{ color: "#1f7a4d", fontWeight: 600 }}>{CLASSIC_2990_MESSAGES.smartAddressAutofill}</span>
                          ) : null}
                        </div>
                      </div>
                      <Button
                        className="classic-2990-search"
                        disabled={isAddressSearchLoading || !String(parcelAddressSearch || "").trim()}
                        onClick={this.handleAddressSearchClick}
                        endIcon={isAddressSearchLoading ? <CircularProgress color="inherit" size={16} /> : null}
                      >
                        {CLASSIC_2990_ACTIONS.searchPropertyDetails}
                      </Button>
                      <Menu
                        anchorEl={addressMenuAnchor}
                        open={Boolean(addressMenuAnchor) && addressChoices.length > 1}
                        onClose={this.closeAddressParcelMenu}
                        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                        transformOrigin={{ vertical: "top", horizontal: "right" }}
                        getContentAnchorEl={null}
                      >
                        {addressChoices.map((pair) => (
                          <MenuItem
                            key={`${pair.gush}-${pair.helka}-${pair.objectId != null ? pair.objectId : ""}`}
                            onClick={() => this.handleAddressChoiceClick(pair)}
                          >
                            {getClassic2990ParcelChoiceLabel(pair)}
                          </MenuItem>
                        ))}
                      </Menu>
                    </div>

                    <div className="classic-2990-property-grid">
                      {PROPERTY_FIELDS.map((field) => this.render2990FieldPair(field))}
                    </div>

                    <div className="classic-2990-fraction">
                      <div className="classic-2990-fraction-caption">
                        <PieChartIcon className="classic-2990-section-icon" />
                        {CLASSIC_2990_LABELS.propertyShare}
                      </div>
                      <label
                        className="classic-2990-fraction-term"
                        htmlFor={getClassic2990FieldId(FRACTION_NUMERATOR_FIELD.name)}
                        id={`${getClassic2990FieldId(FRACTION_NUMERATOR_FIELD.name)}-label`}
                      >
                        {FRACTION_NUMERATOR_FIELD.label}
                      </label>
                      {this.render2990FieldControl(
                        FRACTION_NUMERATOR_FIELD,
                        getClassic2990FieldId(FRACTION_NUMERATOR_FIELD.name),
                        { hideHelper: true, className: "classic-2990-fraction-numerator" }
                      )}
                      <span className="classic-2990-fraction-bar" aria-hidden="true" />
                      <label
                        className="classic-2990-fraction-term"
                        htmlFor={getClassic2990FieldId(FRACTION_DENOMINATOR_FIELD.name)}
                        id={`${getClassic2990FieldId(FRACTION_DENOMINATOR_FIELD.name)}-label`}
                      >
                        {FRACTION_DENOMINATOR_FIELD.label}
                      </label>
                      {this.render2990FieldControl(
                        FRACTION_DENOMINATOR_FIELD,
                        getClassic2990FieldId(FRACTION_DENOMINATOR_FIELD.name),
                        { hideHelper: true, className: "classic-2990-fraction-denominator" }
                      )}
                      <div className="classic-2990-fraction-message" aria-live="polite">
                        {fractionErrors.map((message) => (
                          <span key={message}>{message}</span>
                        ))}
                      </div>
                    </div>
                  </section>
                </div>
                <div className="classic-2990-actions">
                  <Button
                    className="classic-2990-save"
                    onClick={this.savePersonalDetailsOf2990}
                  >
                    <span className="classic-2990-save-label">
                      {CLASSIC_2990_ACTIONS.savePersonalDetails}
                    </span>
                  </Button>
                </div>
              </div>
            </CustomAcordion>
          ) : null}

          {!isFullyExempt ? (
            <CustomAcordion summaryText={CLASSIC_2990_LABELS.documentsTitle} defaultExpanded={true}>
              <div className="deal-sum-docs">
                <div className="deal-sum-docs-block">
                  <Typography variant="subtitle1" align="right">
                    {CLASSIC_2990_LABELS.additionalActions}
                  </Typography>
                  <div className="deal-sum-action-buttons">
                    <Button
                      className="deal-sum-admin-btn"
                      endIcon={<DescriptionOutlinedIcon />}
                      onClick={this.generate2990}
                    >
                      {CLASSIC_2990_ACTIONS.generateForm2990}
                    </Button>
                    <Button
                      className="deal-sum-admin-btn"
                      endIcon={<DescriptionOutlinedIcon />}
                      onClick={this.generateDeductions}
                    >
                      {CLASSIC_2990_ACTIONS.generateDeductions}
                    </Button>
                    {this.props.role === "admin" ? this.renderAdminDocActions() : null}
                  </div>
                </div>
                <div className="deal-sum-docs-block">
                  <Typography variant="subtitle1" align="right">
                    {CLASSIC_2990_LABELS.onlineFiles}
                  </Typography>
                  <div className="deal-sum-file-buttons">
                    {preCalcPartsData.map((currentPart, index) => (
                      <div className="deal-sum-file-group" key={"part" + index}>
                        {preCalcPartsData.length > 1 ? (
                          <div className="deal-sum-file-group-title">עסקה מספר - {index + 1}</div>
                        ) : null}
                        <div className="deal-sum-file-buttons">
                          {currentPart.needsMutav ? (
                            <Button
                              className="deal-sum-primary-btn"
                              onClick={() => this.generate2990Json("mutav", index)}
                              endIcon={<GetAppOutlinedIcon />}
                              variant="contained"
                            >
                              {CLASSIC_2990_ACTIONS.generateMutavFile}
                            </Button>
                          ) : null}
                          {currentPart.needsRegTax ? (
                            <Button
                              className="deal-sum-primary-btn"
                              onClick={() => this.generate2990Json("linear", index)}
                              endIcon={<GetAppOutlinedIcon />}
                              variant="contained"
                            >
                              {CLASSIC_2990_ACTIONS.generateLinearFile}
                            </Button>
                          ) : null}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </CustomAcordion>
          ) : null}
        </div>

        <Box className="pre-calc-results-note" mt={2}>
          נכון לשנת 2025, יחיד אשר הכנסתו החייבת (כולל שבח מקרקעין) תעלה על 721,560 ש"ח, יהיה חייב במס נוסף (מס יסף) על כל שקל נוסף בשיעור
          של 3%. מס יסף יחול בגין שבח ממכירת זכות במקרקעין המהווה דירת מגורים במידה ושווי מכירתה מעל 5,382,285 ש"ח והמכירה אינה פטורה ממס
          לפי כל דין. "הכנסה חייבת" – כהגדרתה בסעיף 121ב לפקודת מס הכנסה. ראה הוראת ביצוע 9/15 רשות המיסים. בהתאם לחוק ההתייעלות הכלכלית
          התשפ"ה 2024, נוסף על האמור לעיל, יחיד אשר הכנסתו החייבת ממקורות הוניים בשנת המס עלתה על הסכום של 721,560 ש"ח, יהיה חייב במס נוסף
          על חלק הכנסתו החייבת ממקורות הוניים העולה על הסכום האמור, בשיעור של 2%.
          <br />
          "הכנסה חייבת" – כהגדרתה בסעיף 121ב לפקודת מס הכנסה. ראה הוראת ביצוע 9/15 רשות המיסים.
        </Box>
      </Box>
    );
  }

  getSummaryRows({ shevahReali11, shevahReali11afterKizuz, discountRabPercent, prisaData, isKizuzShown, isPrisaShown, isAfkaaShown }) {
    const rows = [{ label: 'סה"כ שבח בעסקה', value: this.formatSumAmount(shevahReali11) }];
    if (isKizuzShown) {
      rows.push({ label: 'סה"כ שבח לאחר קיזוז הפסדים', value: this.formatSumAmount(shevahReali11afterKizuz) });
    }
    rows.push({ label: 'סה"כ מס שבח', value: this.formatSumAmount(this.getFinalMasShevahPrePrisa()) });
    if (discountRabPercent) {
      rows.push({ label: "הנחת רבינוביץ", value: `${discountRabPercent * 100}%` });
    }
    if (isPrisaShown) {
      rows.push({ label: 'סה"כ מס שבח לאחר פריסה', value: this.formatSumAmount(prisaData.totalPreAfkaa) });
    }
    if (isAfkaaShown) {
      rows.push({ label: "זיכוי הפקעה", value: this.formatSumAmount(this.getAfterAfkaa()) });
    }
    rows.push({ label: 'סה"כ מס לתשלום', value: this.formatSumAmount(this.getFinalTax()), isFinal: true });
    return rows;
  }

  formatFactAmount(amount) {
    if (typeof amount === "string") return amount;
    if (!Number.isFinite(amount)) return "0";
    return amount.toLocaleString(undefined, { maximumFractionDigits: 2 });
  }

  formatSumAmount(amount) {
    if (typeof amount === "string") return amount;
    if (!Number.isFinite(amount)) return "0";
    return amount.toLocaleString(undefined, { maximumFractionDigits: 0 });
  }

  getStreetsForCity(cityName) {
    if (!cityName || !this.props.addresses) return [];
    return this.props.addresses.filter((x) => x.cityName === cityName).map((x) => x.streetName);
  }

  closeAddressParcelMenu = () => {
    this.setState({
      addressMenuAnchor: null,
      addressChoices: []
    });
  };

  handleParcelSearchChange = (e) => {
    this.parcelLookupReq += 1;
    this.setState({
      parcelAddressSearch: e.target.value,
      parcelAddressError: "",
      isGovMapAutofill: false,
      isAddressSearchLoading: false,
      addressChoices: [],
      addressMenuAnchor: null
    });
  };

  handleAddressKeyPress = (e) => {
    if (e.key !== "Enter") return;
    e.preventDefault();
    this.handleAddressSearchClick();
  };

  applyAddressAutofill = (patch) => {
    this.setState((prev) => ({
      doc2990Fields: {
        ...prev.doc2990Fields,
        ...patch
      },
      streets: patch.assetCity ? this.getStreetsForCity(patch.assetCity) : prev.streets,
      parcelAddressSearch: "",
      parcelAddressError: "",
      isGovMapAutofill: true,
      isAddressSearchLoading: false,
      addressChoices: [],
      addressMenuAnchor: null
    }));
  };

  getResolvedAutofillPatch = (lot, parcel, parsedAddress) => {
    const catalogAddress = resolveClassicCatalogAddress(parsedAddress, this.props.addresses || []);
    return buildPropertyAutofillPatch({
      lot,
      parcel,
      resolvedAddress: catalogAddress,
      parsedAddress
    });
  };

  handleAddressSearchClick = async () => {
    const trimmedAddress = String(this.state.parcelAddressSearch || "").trim();
    const parsedAddress = parseSmartLookupAddress(trimmedAddress);
    if (!parsedAddress) {
      this.parcelLookupReq += 1;
      this.setState({
        isAddressSearchLoading: false,
        isGovMapAutofill: false,
        addressChoices: [],
        addressMenuAnchor: null,
        parcelAddressError: CLASSIC_2990_MESSAGES.smartAddressFormatError
      });
      return;
    }

    const govMapCredential = config.govMapApiToken;
    if (!govMapCredential || !String(govMapCredential).trim()) {
      this.parcelLookupReq += 1;
      this.setState({
        isAddressSearchLoading: false,
        parcelAddressError: CLASSIC_2990_MESSAGES.govMapUnavailable
      });
      return;
    }

    const req = ++this.parcelLookupReq;
    this.setState({
      isAddressSearchLoading: true,
      isGovMapAutofill: false,
      parcelAddressError: "",
      addressChoices: [],
      addressMenuAnchor: null
    });

    try {
      const pairs = await searchLotParcelFromAddress(govMapCredential, parsedAddress.lookupAddress);
      if (req !== this.parcelLookupReq) return;

      if (!pairs.length) {
        this.setState({
          isAddressSearchLoading: false,
          parcelAddressError: CLASSIC_2990_MESSAGES.addressNoMatch
        });
        return;
      }

      if (pairs.length === 1) {
        this.applyAddressAutofill(this.getResolvedAutofillPatch(pairs[0].gush, pairs[0].helka, parsedAddress));
        return;
      }

      this.setState({
        isAddressSearchLoading: false,
        addressChoices: pairs,
        addressMenuAnchor: this.parcelMenuAnchorRef.current
      });
    } catch {
      if (req !== this.parcelLookupReq) return;
      this.setState({
        isAddressSearchLoading: false,
        parcelAddressError: CLASSIC_2990_MESSAGES.addressSearchFailed
      });
    }
  };

  handleAddressChoiceClick = (pair) => {
    const parsedAddress = parseSmartLookupAddress(this.state.parcelAddressSearch);
    this.applyAddressAutofill(this.getResolvedAutofillPatch(pair.gush, pair.helka, parsedAddress));
  };

  onCityChange(newCity) {
    this.handleOnChange({ target: { name: "assetCity", value: newCity } });

    this.setState({ streets: this.getStreetsForCity(newCity) });
  }

  savePersonalDetailsOf2990 = () => {
    filesService.update2990SpecificFields(this.props.match.params.dealId, this.state.doc2990Fields).then((res) => {
      if (res.success) {
        Swal.fire("נתונים נשמרו בהצלחה", "", "success");
      }
    });
  };

  handleOnChange = (e) => {
    const fieldName = e.target.name;
    const doc2990Fields = { ...this.state.doc2990Fields, [fieldName]: e.target.value };
    const nextState = { doc2990Fields };

    if (DOC_2990_AUTOFILL_TARGET_FIELDS.includes(fieldName)) {
      if (this.state.isGovMapAutofill) {
        nextState.isGovMapAutofill = false;
      }
      this.parcelLookupReq += 1;
      nextState.isAddressSearchLoading = false;
      nextState.addressChoices = [];
      nextState.addressMenuAnchor = null;
    }

    if (this.state.jsonFieldErrors[fieldName]) {
      const jsonFieldErrors = { ...this.state.jsonFieldErrors };
      delete jsonFieldErrors[fieldName];
      nextState.jsonFieldErrors = jsonFieldErrors;
    }

    this.setState(nextState);
  };

  confirmTaxAuthorityDocumentGeneration = async () => {
    return confirmTaxAuthorityDocumentGenerationOncePerDeal({
      dealId: this.props.match.params.dealId,
      fullName: this.props.fullName,
      licenseNumber: this.props.licenseNumber,
      disableTaxAuthorityDocumentConfirmation: this.props.disableTaxAuthorityDocumentConfirmation
    });
  };

  generate2990 = async () => {
    const confirmed = await this.confirmTaxAuthorityDocumentGeneration();
    if (!confirmed) {
      return;
    }

    const dataForGenerate2990Doc = getClassic2990RequestFields(this.state.doc2990Fields);
    dataForGenerate2990Doc.dealId = this.props.match.params.dealId;

    filesService.generate2990(dataForGenerate2990Doc).catch(() => {
      Swal.fire("היתה בעיה ביצירת המסמך", "במידה ובעיה זו ממשיכה בבקשה צרו איתנו קשר", "warning");
    });
  };

  generateDeductions = async () => {
    const confirmed = await this.confirmTaxAuthorityDocumentGeneration();
    if (!confirmed) {
      return;
    }

    filesService.generateDeductions(this.props.match.params.dealId).catch(() => {
      Swal.fire("היתה בעיה ביצירת המסמך", "במידה ובעיה זו ממשיכה בבקשה צרו איתנו קשר", "warning");
    });
  };

  generate2990Json = async (dealTaxType, dealIndex) => {
    const dataForGenerate2990Doc = getClassic2990RequestFields(this.state.doc2990Fields);
    dataForGenerate2990Doc.dealId = this.props.match.params.dealId;

    const result = validate2990JsonFieldsDetailed(dataForGenerate2990Doc);
    if (result.message) {
      this.setState({ jsonFieldErrors: result.fieldErrors });
      this.focusClassic2990Field(result.firstFieldName);
      return;
    }
    this.setState({ jsonFieldErrors: {} });

    filesService.generate2990Json(dataForGenerate2990Doc, dealTaxType, dealIndex, this.props.preCalc.preCalcPartsData.length).catch(() => {
      Swal.fire("היתה בעיה ביצירת המסמך", "במידה ובעיה זו ממשיכה בבקשה צרו איתנו קשר", "warning");
    });
    filesService.update2990SpecificFields(this.props.match.params.dealId, this.state.doc2990Fields);
  };

  addDealTest = () => {
    Swal.fire({
      title: "הזן תיאור בדיקה",
      input: "text",
      showCancelButton: true,
      cancelButtonText: "ביטול",
      confirmButtonText: "המשך",
      preConfirm: (testDescription) => {
        if (!testDescription) return Swal.showValidationMessage("יש להזין תיאור בדיקה");
        return adminService
          .addDealTest(testDescription, { preCalc: this.props.preCalc, mainCalc: this.props.mainCalc }, "btax")
          .then((res) => res)
          .catch((e) => Swal.showValidationMessage(`בקשה נדחתה: ${e}`));
      }
    }).then((result) => {
      if (result.isConfirmed && result.value.success) {
        Swal.fire({
          icon: "success",
          title: `הבדיקה נשמרה בהצלחה`,
          confirmButtonText: "המשך"
        });
      }
    });
  };

  getActualPriceBought() {
    let totalBought = 0;
    for (const part of this.props.mainCalc.calculatedData.deductionMat) {
      // totalBought += part[0].amount;
      totalBought += part[0].amountAfterCurrencyConversion || 0;
    }
    return totalBought;
  }

  getTopValues() {
    const topValues = { shevahReali11: 0, shoviRechishaLehishuvMas: 0, shoviMechiraHaiavMas: 0, shoviRechisaMasMetoam: 0 };
    for (const part of this.props.mainCalc.calculatedData.dataPerPart) {
      topValues.shevahReali11 += (part.shevahRealiMutav11 || 0) + (part.shevahRealiRegTax11 || 0);
      topValues.shoviRechishaLehishuvMas += part.sumAmountMutav + part.sumAmountRegTax;
      topValues.shoviMechiraHaiavMas += part.baseDeltaMasMutav + part.zabanMasMutavToPay + part.baseDeltaRegTax + part.zabanMasRegToPay;
      topValues.shoviRechisaMasMetoam += part.sumMemudadMutav + part.sumMemudadRegTax;
    }

    return topValues;
  }

  getFinalMasShevahPrePrisa() {
    if (this.props.mainCalc.prisa.shouldTryPrisa) {
      return this.props.mainCalc.calculatedData.dataPerPart.reduce(
        (a, b) =>
          a +
          (b.finalLinearBeforePrisa20 || 0) +
          (b.finalLinearBeforePrisa25 || 0) +
          (b.finalLinearBeforePrisa47 || 0) +
          (b.finalMutavBeforePrisa25 || 0) +
          (b.finalInflationLinear10 || 0),
        0
      );
    } else {
      return this.props.mainCalc.calculatedData.dataPerPart.reduce(
        (a, b) => a + (b.finalLinearTaxAllPreAfkaa21 || 0) + (b.finalMutavTaxAllPreAfkaa21 || 0),
        0
      );
    }
  }

  getMaximalRabinovich() {
    return this.props.mainCalc.calculatedData.dataPerPart.reduce((a, b) => Math.max(a, b.discountRabPercent || 0), 0);
  }

  getPrisaData() {
    let totalPrisaRev = 0,
      maxPrisaYearsAllowed = 0,
      totalPreAfkaa = 0;

    for (const part of this.props.mainCalc.calculatedData.dataPerPart) {
      maxPrisaYearsAllowed = Math.max(part.prisaData[0].length, maxPrisaYearsAllowed);

      totalPrisaRev += part.finalLinearBeforePrisa47 - part.finalLinear47;
      totalPrisaRev += part.finalMutavBeforePrisa25 - part.finalMutav25;
      totalPrisaRev += part.finalLinearBeforePrisa25 - part.finalLinear25;
      totalPrisaRev += part.finalLinearBeforePrisa20 - part.finalLinear20;

      totalPreAfkaa += (part.finalLinearTaxAllPreAfkaa21 || 0) + (part.finalMutavTaxAllPreAfkaa21 || 0);
    }
    return { totalPrisaRev, maxPrisaYearsAllowed, totalPreAfkaa };
  }

  getAfterAfkaa() {
    return this.props.mainCalc.calculatedData.dataPerPart.reduce(
      (a, b) => a + (b.finalLinearTaxAll24 || 0) + (b.finalMutavTaxAll24 || 0),
      0
    );
  }

  getFinalTax() {
    return this.props.mainCalc.calculatedData.dataPerPart.reduce(
      (a, b) => a + (b.actualFinalLinear26 || 0) + (b.actualFinalMutav26 || 0),
      0
    );
  }
}

const mapStateToProps = (state) => {
  return {
    role: state.loggedinReducer.role,
    fullName: state.loggedinReducer.fullName,
    licenseNumber: state.loggedinReducer.licenseNumber,
    disableTaxAuthorityDocumentConfirmation: state.loggedinReducer.disableTaxAuthorityDocumentConfirmation
  };
};

export default withRouter(connect(mapStateToProps)(ClassicDealSumCalc));
